module.exports = __webpack_public_path__ + "img/1526124070.7f91c236.jpg";